export const CERTIFICATES_CONFIRMATION_TYPES = [
  {
    id: "whatsapp",
    icon: "whatsapp",
    label: "Отправить в WhatsApp",
  },
  // {
  //   id: "mail",
  //   icon: "mail",
  //   label: "Отправить на почту",
  // },
  {
    id: "phone",
    icon: "phone",
    label: "Позвонить по номеру",
  },
  {
    id: "push",
    icon: "notification",
    label: "Push в RC.Pay",
  },
];
